<template>
  <div class="log-info">
    <h3>Лента</h3>
    <p v-if="thread.items.length == 0">Изменений пока нет</p>
    <div v-if="thread.items.length > 0">
      <p v-for="(item, index) of thread.items" :key="index">
        {{ item.created_date + " " + item.description }}
      </p>
    </div>

    <div v-if="isKeyWordType">
      <h3>Ключевые слова</h3>
      <p v-if="keywords.items.length == 0">Изменений пока нет</p>
      <div v-if="keywords.items.length > 0">
        <p v-for="(item, index) of keywords.items" :key="index">
          {{ item.created_date + " " + item.description }}
        </p>
      </div>
    </div>
    <div v-if="isSourceType">
      <h3>Источники</h3>
      <p v-if="sources.items.length == 0">Изменений пока нет</p>
      <div v-if="sources.items.length > 0">
        <p v-for="(item, index) of sources.items" :key="index">
          {{ item.created_date + " " + item.description }}
        </p>
      </div>
    </div>

    <h3>Фильтры</h3>
    <p v-if="filters.items.length == 0">Изменений пока нет</p>
    <div v-if="filters.items.length > 0">
      <p v-for="(item, index) of filters.items" :key="index">
        {{ item.created_date + " " + item.description }}
      </p>
    </div>

    <h3>Интервалы и ретроспективы</h3>
    <p v-if="periods.items.length == 0">Изменений пока нет</p>
    <div v-if="periods.items.length > 0">
      <p v-for="(item, index) of periods.items" :key="index">
        {{ item.created_date + " " + item.description }}
      </p>
    </div>

  </div>
</template>

<script>
// api
import { getApiLogApi } from "../../../../../api/feeds";

// vuex
import { mapGetters } from "vuex";

export default {
  name: "Logi",
  data() {
    return {
      thread: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
            thread: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
      keywords: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
      sources: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
      filters: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
      periods: {
        start: 0,
        limit: 0,
        items: [
          {
            "id": 0,
            "type": "threads",
            "created_date": "2023-03-15 16:34:21",
            "description": "string",
            "api": {
            "id": 0,
            "name": "string"
            },
            "thread": {
            "id": 0,
            "name": "string"
            }
          }
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["users", "isAdmin"]),
    feedUid() {
      return this.$store.getters["feedUid"](this.$route.params.threadId)
        ? this.$store.getters["feedUid"](this.$route.params.threadId)
        : "";
    },
    feed() {
      return this.$store.getters['feed'](this.$route.params.threadId)
        ?
        this.$store.getters['feed'](this.$route.params.threadId)
        :
        [];
    },
    isKeyWordType() {
      return this.feed.threadtype === 'keywords';
    },
    isSourceType() {
      return this.feed.threadtype === 'profiles';
    },
  },
  methods: {
    loadThreadExtended() {
      let params = {
        thread_id: parseInt(this.$route.params.threadId),
        api_id: parseInt(this.feedUid),
        type: "threads",
        date_from: "2022-01-01 16:34:21",
        date_to: "2023-08-25 18:14:21",
        start: 0,
        limit: 20,
      };
      console.log("feedUid", this.feedUid);
      getApiLogApi(params).then((resp) => {
        this.thread = resp.data;
      });
    },
    loadPeriodsExtended() {
      let params = {
        thread_id: parseInt(this.$route.params.threadId),
        api_id: parseInt(this.feedUid),
        type: "periods",
        date_from: "2022-01-01 16:34:21",
        date_to: "2023-08-25 18:14:21",
        start: 0,
        limit: 20,
      };
      console.log("feedUid", this.feedUid);
      getApiLogApi(params).then((resp) => {
        this.periods = resp.data;
      });
    },
    loadKeywordsExtended() {
      let params = {
        thread_id: parseInt(this.$route.params.threadId),
        api_id: parseInt(this.feedUid),
        type: "keywords",
        date_from: "2022-01-01 16:34:21",
        date_to: "2023-08-25 18:14:21",
        start: 0,
        limit: 20,
      };
      console.log("feedUid", this.feedUid);
      getApiLogApi(params).then((resp) => {
        this.keywords = resp.data;
      });
    },
    loadSourcesExtended() {
      let params = {
        thread_id: parseInt(this.$route.params.threadId),
        api_id: parseInt(this.feedUid),
        type: "sources",
        date_from: "2022-01-01 16:34:21",
        date_to: "2023-08-25 18:14:21",
        start: 0,
        limit: 20,
      };
      console.log("feedUid", this.feedUid);
      getApiLogApi(params).then((resp) => {
        this.sources = resp.data;
      });
    },
    loadFiltersExtended() {
      let params = {
        thread_id: parseInt(this.$route.params.threadId),
        api_id: parseInt(this.feedUid),
        type: "filters",
        date_from: "2022-01-01 16:34:21",
        date_to: "2023-08-25 18:14:21",
        start: 0,
        limit: 20,
      };
      console.log("feedUid", this.feedUid);
      getApiLogApi(params).then((resp) => {
        this.filters = resp.data;
      });
    },
  },
  mounted() {
    this.loadThreadExtended();
    this.loadFiltersExtended();
    this.loadKeywordsExtended();
    this.loadPeriodsExtended();
    this.loadSourcesExtended();
  },
};
</script>

<style>
.log-info {
  margin-bottom: 20px;
}
.log-info p {
  padding: 12px 0;
  margin: 0 20px;
  line-height: 1.4;
  border-bottom: 1px solid #dddddd;
}
.log-info__label {
  font-weight: 500;
  margin-right: 10px;
}
</style>